<template>
  <div class="about-page">
    <!-- 页眉部分 -->
    <Header></Header>

    <!-- 导航菜单 -->
    <Nav></Nav>

    <!-- 英雄区域 -->
    <div class="hero">
      <div class="hero-content">
        <h1>学术团队</h1>
        <p>汇聚顶尖人才，共创科研辉煌</p>
      </div>
    </div>

    <div class="main-content">
      <!-- 团队分类标签 -->
      <div class="team-tabs">
        <div
          class="team-tab"
          :class="{ active: activeTab === 'professor' }"
          @click="activeTab = 'professor'">
          教授团队
        </div>
        <div
          class="team-tab"
          :class="{ active: activeTab === 'associate' }"
          @click="activeTab = 'associate'">
          副教授团队
        </div>
        <div
          class="team-tab"
          :class="{ active: activeTab === 'student' }"
          @click="activeTab = 'student'">
          研究生团队
        </div>
      </div>

      <!-- 教授团队 -->
      <div
        v-show="activeTab === 'professor'"
        class="team-content professor-team">
        <div class="professor-list">
          <div
            class="professor-item"
            v-for="p in professors"
            :key="p.id"
            @click="toDetail(p.id)">
            <img
              :src="p.photo"
              alt="photo"
              class="professor-photo"
              @error="setDefaultLogo($event)" />
            <h3 class="professor-name">{{ p.name }}</h3>
            <p class="professor-title">{{ p.title }}</p>
            <p class="professor-research">{{ p.research }}</p>
          </div>
        </div>
      </div>

      <!-- 副教授团队 -->
      <div
        v-show="activeTab === 'associate'"
        class="team-content associate-team">
        <div class="associate-list">
          <div
            class="associate-item"
            v-for="a in associates"
            :key="a.id"
            @click="toDetail(a.id)">
            <img
              :src="a.photo"
              alt="photo"
              class="associate-photo"
              @error="setDefaultLogo($event)" />
            <h3 class="associate-name">{{ a.name }}</h3>
            <p class="associate-title">{{ a.title }}</p>
            <p class="associate-research">{{ a.research }}</p>
          </div>
        </div>
      </div>

      <!-- 研究生团队 -->
      <div v-show="activeTab === 'student'" class="team-content student-team">
        <div class="student-list">
          <div
            class="student-item"
            v-for="s in students"
            :key="s.id"
            @click="toDetail(s.id)">
            <img
              :src="s.photo"
              alt="photo"
              class="student-photo"
              @error="setDefaultLogo($event)" />
            <h3 class="student-name">{{ s.name }}</h3>
            <p class="student-grade">{{ s.grade }}</p>
            <p class="student-research">{{ s.research }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 页脚 -->
    <Footer></Footer>
  </div>
</template>

<script>
import defaultLogo from "@/assets/default-logo.png";
import Header from "../../components/head.vue";
import Nav from "../../components/nav.vue";
import Footer from "../../components/footer.vue";
import { listUser } from "../../api/team";

export default {
  name: "TeamPage",
  components: { Header, Nav, Footer },
  data() {
    return {
      activeTab: "professor",
      professors: [],
      associates: [],
      students: [],
    };
  },
  methods: {
    setDefaultLogo(event) {
      event.target.src = defaultLogo;
    },
    buildAvatarUrl(path) {
      if (!path) return "";
      if (/^https?:\/\//.test(path)) return path;
      // 头像路径通过 /system 代理访问后端
      // 后端返回的路径格式可能是: profile/avatar/xxx.jpg
      const baseUrl =
        process.env.NODE_ENV === "production"
          ? "https://www.modena-ai.com/system/"
          : "http://localhost:3389/";
      return baseUrl + path.replace(/^\/+/, "");
    },
    async getProfessorList() {
      let UserBelong = {
        belongTeam: "professor",
      };
      let res = await listUser(UserBelong);
      if (res.code === 0) {
        let usersData = res.rows;
        for (let i = 0; i < usersData.length; i++) {
          this.professors.push({
            id: usersData[i].userId,
            name: usersData[i].userName,
            title: usersData[i].postGroup,
            research: usersData[i].researchDirection,
            photo: this.buildAvatarUrl(usersData[i].avatar),
          });
        }
      }
    },
    async getAssociateProfessorList() {
      let UserBelong = {
        belongTeam: "associateProfessor",
      };
      let res = await listUser(UserBelong);
      if (res.code === 0) {
        let usersData = res.rows;
        for (let i = 0; i < usersData.length; i++) {
          this.associates.push({
            id: usersData[i].userId,
            name: usersData[i].userName,
            title: usersData[i].postGroup,
            research: usersData[i].researchDirection,
            photo: this.buildAvatarUrl(usersData[i].avatar),
          });
        }
      }
    },
    async getGraduateStudentList() {
      let UserBelong = {
        belongTeam: "graduateStudent",
      };
      let res = await listUser(UserBelong);
      if (res.code === 0) {
        let usersData = res.rows;
        for (let i = 0; i < usersData.length; i++) {
          this.students.push({
            id: usersData[i].userId,
            name: usersData[i].userName,
            grade: usersData[i].postGroup,
            research: usersData[i].researchDirection,
            photo: this.buildAvatarUrl(usersData[i].avatar),
          });
        }
      }
    },
    toDetail(id) {
      this.$router.push({
        path: "/team/detail/" + id,
      });
    },
  },
  mounted() {
    this.getProfessorList();
    this.getAssociateProfessorList();
    this.getGraduateStudentList();
  },
};
</script>

<style scoped>
.hero {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="400"><rect width="1200" height="400" fill="%23004080"/><circle cx="200" cy="150" r="50" fill="%23FFD700" opacity="0.3"/><circle cx="800" cy="250" r="80" fill="%23FFD700" opacity="0.2"/><rect x="400" y="100" width="300" height="200" fill="%23FFD700" opacity="0.1"/></svg>');
  background-size: cover;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
}
.hero-content h1 {
  font-size: 2.5em;
  margin-bottom: 20px;
}
.hero-content p {
  font-size: 1.1em;
}

/* ==================== 主体内容 ==================== */
.main-content {
  max-width: 1200px;
  margin: 60px auto;
  padding: 0 20px;
}

/* ==================== 团队标签 ==================== */
.team-tabs {
  display: flex;
  justify-content: center;
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 40px;
  flex-wrap: wrap;
}

.team-tab {
  padding: 14px 28px;
  font-size: 1.05rem;
  color: #333;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.team-tab:hover {
  color: #0055aa;
}

.team-tab.active {
  color: #003366;
  font-weight: 600;
}

.team-tab.active::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 100%;
  height: 3px;
  background-color: #003366;
  border-radius: 2px;
}

/* ==================== 教授团队 ==================== */
.professor-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
}

.professor-item {
  background: #fff;
  padding: 20px;
  width: 260px;
  text-align: center;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
}

.professor-item:hover {
  transform: translateY(-6px);
}

.professor-photo {
  width: 140px;
  height: 140px;
  object-fit: cover;
  border-radius: 50%;
  margin-bottom: 15px;
}

.professor-name {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 8px;
}

.professor-title {
  font-size: 0.95rem;
  color: #555;
  margin-bottom: 8px;
}

.professor-research {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.5;
}

/* ==================== 副教授团队 ==================== */
.associate-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
}

.associate-item {
  background: #fff;
  padding: 20px;
  width: 260px;
  text-align: center;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
}

.associate-item:hover {
  transform: translateY(-6px);
}

.associate-photo {
  width: 140px;
  height: 140px;
  object-fit: cover;
  border-radius: 50%;
  margin-bottom: 15px;
}

.associate-name {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 8px;
}

.associate-title {
  font-size: 0.95rem;
  color: #555;
  margin-bottom: 8px;
}

.associate-research {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.5;
}

/* ==================== 研究生团队 ==================== */
.student-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
}

.student-item {
  background: #fff;
  padding: 20px;
  width: 220px;
  text-align: center;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
}

.student-item:hover {
  transform: translateY(-6px);
}

.student-photo {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 50%;
  margin-bottom: 15px;
}

.student-name {
  font-size: 1.1rem;
  font-weight: bold;
  margin-bottom: 6px;
}

.student-grade {
  font-size: 0.9rem;
  color: #555;
  margin-bottom: 6px;
}

.student-research {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.5;
}

/* ==================== 响应式 ==================== */
@media (max-width: 768px) {
  .team-tab {
    padding: 10px 18px;
    font-size: 0.95rem;
  }

  .professor-item,
  .associate-item,
  .student-item {
    width: 80%;
    max-width: 300px;
  }

  .professor-photo,
  .associate-photo {
    width: 120px;
    height: 120px;
  }

  .student-photo {
    width: 100px;
    height: 100px;
  }
}
</style>
